export const INTERACTION_CONFLICT_ISSUE_TYPE = 'MINE_INTERACTION_CONFLICT';